import { IOTranslation } from 'locales/de/pages/internationalOffice';

const en: IOTranslation = {
  title: 'International Office',
  manageUsers: 'User Management',
  manageCourses: 'Course Management',
  manageEvents: 'Event Management',
  myCourses: 'My Courses',
  myEvents: 'My Events',
  coursesTitleLong: 'Course Registration',
  coursesTitle: 'Courses',
  eventsTitleLong: 'Event Registration',
  eventsTitle: 'Events',
  users: {
    homeUniversity: 'Home University',
    courseOfStudies: 'Course of Studies',
    semester: 'Semester',
    newIOUser: 'New International Office User',
    editIOUser: 'International Office User Editing',
    search: 'Search',
    alerts: {
      error: {
        loadingUsers: 'Users could not be fetched.',
        creatingUser: 'New user could not be created.',
        checkingEmail: 'The email could not be tested.',
        updatingUser: 'User could not be edited.',
        deletingUser: 'User could not be deleted.'
      },
      success: {
        createdUser: 'New user was successfully created.',
        updatedUser: 'User was successfully edited.',
        deletedUser: 'User was successfully deleted.'
      }
    },
    deleteConfirm: {
      title: 'Really delete?',
      message: 'Are you sure you want to delete this user?'
    }
  },
  courses: {
    newIOCourse: 'New International Office Course',
    editIOCourse: 'International Office Course Editing',
    facultyReport: 'Faculty Report',
    officersReport: 'Officers Report',
    reports: 'Reports',
    orderNumber: 'Priority',
    faculty: 'Faculty',
    courseName: 'Course',
    courseNumber: 'Code',
    courseDescription: 'File',
    courseOfficer: 'Contact',
    semester: 'Semester',
    isWinter: 'Winter',
    isSummer: 'Summer',
    isAWPM: 'Electives',
    isAWPMHeader: 'Elective',
    AWPM: 'AWPM',
    FWPM: 'FWPM',
    type: 'Typ',
    ects: 'ECTS-Credits',
    degree: 'Degree',
    enroll: 'Enrol',
    unenroll: 'Unenrol',
    notAvailable: 'not available in current semester',
    alerts: {
      error: {
        loadingCourses: 'Courses could not be loaded',
        creatingCourse: 'New Course could not be created.',
        updatingCourse: 'Course could not be edited.',
        deletingCourse: 'Course could not be deleted.',
        savingCourseCode: 'There exists already a Course with this Code',
        savingCourseDescription: 'Course description could not be saved.',
        enrollingCourse: 'Error when enrolling the course.',
        unenrollingCourse: 'Error when unenrolling the course.'
      },
      success: {
        createdCourse: 'New course was successfully created.',
        updatedCourse: 'Course was successfully edited.',
        deletedCourse: 'Course was successfully deleted.',
        enrolledCourse: 'You have successfully enrolled the course.',
        unenrolledCourse: 'You have successfully unenrolled the course.'
      }
    },
    deleteConfirm: {
      title: 'Really delete?',
      message: 'Are you sure you want to delete this course?'
    }
  },
  events: {
    newIOEvent: 'New International Office Event',
    eidtIOEvent: 'International Office Event Editing',
    eventsReport: 'Events Report',
    organisersReport: 'Events Organisers Report',
    orderNumber: 'Priority',
    eventName: 'Event',
    dateAndTime: 'Date and Time',
    date: 'Date',
    eventDescription: 'Description',
    participants: 'Participants',
    costs: 'Costs',
    registrationDeadline: 'Register until',
    meetingPoint: 'Meeting Point',
    eventOfficer: 'Responsible Person',
    contact: 'Contact',
    actions: 'Actions',
    participantsTypes: {
      ALL_INTERNATIONAL_STUDENTS: 'All International Students',
      EXCHANGE_STUDENTS: 'Exchange Students',
      MASTER_INTERNATIONAL_STUDENTS: 'Master International Students'
    },
    alerts: {
      error: {
        loadingEvents: 'Events could not be loaded',
        creatingEvent: 'New Event could not be created.',
        updatingEvent: 'Event could not be edited.',
        deletingEvent: 'Event could not be deleted.',
        savingCourseDescription: 'Event description could not be saved.',
        enrollingEvent: 'Error when enrolling the event.',
        unenrollingEvent: 'Error when unenrolling the event.'
      },
      success: {
        createdEvent: 'New Event was successfully created.',
        updatedEvent: 'Event was successfully edited.',
        deletedEvent: 'Event was successfully deleted.',
        enrolledEvent: 'You have successfully enrolled the event.',
        unenrolledEvent: 'You have successfully unenrolled the event.'
      }
    },
    deleteConfirm: {
      title: 'Really delete?',
      message: 'Are you sure you want to delete this event?'
    }
  }
};

export default en;
